let currentPage = 1;

jQuery(($) => {

    $("#search-load-more").on('click', () => {

        currentPage++;

        let regexAuthorPath = /^\/author\/\w+/;
        let author = regexAuthorPath.test(window.location.pathname)
            ? window.location.pathname.split('/')[2]
            : '';
    
        $.ajax({
            type: 'GET',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'digitalks_load_more',
                paged: currentPage,
                s: new URLSearchParams(window.location.search).get('s'),
                author,
            },
            success: res => {
                if (res) {
                    $('#myList').append(res);
                } else {
                    $('#search-load-more').css('display', 'none')
                }
            },
        });

    });

});
